function isMfaPreAuthRequest (config) {
  if (!config || !config.url) return false

  const url = String(config.url).toLowerCase()
  return url.includes('/auth/mfa/verify') || url.includes('/auth/mfa/resend')
}

function handleMfaPreAuthUnauthorized (vueApp) {
  if (!vueApp) return

  try {
    if (vueApp.$store && vueApp.$store._actions && vueApp.$store._actions['mfa/clearMfaSession']) {
      vueApp.$store._actions['mfa/clearMfaSession'][0]()
    }
  } catch (_) {}

  if (vueApp.$noty && vueApp.$noty.error) {
    vueApp.$noty.error('Sua sessão de verificação expirou. Faça login novamente para receber um novo código.')
  }

  if (vueApp.$router) {
    vueApp.$router.push('/login')
  }
}

export {
  isMfaPreAuthRequest,
  handleMfaPreAuthUnauthorized
}
